import { useRouteError } from "react-router";
import { FC } from "react";
import styles from "./ErrorPage.module.css";
import { Text } from "@postenbring/hedwig-react";
import Translated from "../infrastructure/translation/Translated";
import { isErrorWithDisplayMessage } from "../infrastructure/errors/useUnrecoverableError";
import { TranslationKey } from "../infrastructure/translation/translator";

const ErrorPage: FC = () => {
  const error = useRouteError();

  const errorTextKey: TranslationKey = isErrorWithDisplayMessage(error)
    ? (error.message as TranslationKey)
    : "errorpage.body";

  console.error(error);

  return (
    <div className={styles.outerContainer}>
      <Text variant="h1" as="h1" size="min">
        <Translated textKey={"errorpage.header"} />
      </Text>
      <p>
        <Translated textKey={errorTextKey} />
      </p>
    </div>
  );
};

export default ErrorPage;
